export const SET_NOTIFICATION_IS_OPEN = 'SET_NOTIFICATION_IS_OPEN';
export const RESET_NOTIFICATION_IS_OPEN = 'RESET_NOTIFICATION_IS_OPEN';
export const SET_NOTIFICATION_TYPE = 'SET_NOTIFICATION_TYPE';
export const RESET_NOTIFICATION_TYPE = 'RESET_NOTIFICATION_TYPE';
